import { Capability } from 'homey-lib/webpack/index.js';

import { round } from '../../lib/math';
import { Glyph } from '../common/Glyph';

import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';
import styles from './IndicatorNumber.module.css';

const POWER_IMPORT_COLOR = theme.color.highlight;
const POWER_EXPORT_COLOR = theme.color.success;
const POWER_UNKNOWN_COLOR = theme.color.mono_400;

export function IndicatorNumber(props) {
  const [value, , capabilityObj] = useCapabilityValue({
    deviceId: props.device.id,
    capabilityId: props.capabilityId,
  });

  const isPowerIndicator = isPowerCapabilityId(props.capabilityId);

  const renderValue = (() => {
    if (value == null) {
      return '-';
    }

    if (isPowerIndicator === true) {
      if (value === 0) {
        return 0;
      }

      if (value < 0 && value > -1) {
        return Math.floor(value);
      }

      if (value > 0 && value < 1) {
        return Math.ceil(value);
      }

      return round(value, 0);
    }

    return round(value, capabilityObj?.decimals);
  })();

  const unitsPostFix = capabilityObj?.units ? ` ${capabilityObj.units}` : '';
  const label = `${renderValue}${unitsPostFix}`;

  if (isPowerIndicator === true) {
    const powerColor = getPowerColor(value);

    return (
      <div className={styles.status} style={{ '--prop-text-color': powerColor }}>
        <Glyph
          className={styles.statusIcon}
          source={glyph.core.electricityBolt}
          color={powerColor}
          size={theme.icon.size_small}
        />
        <div className={styles.powerStatusText}>{label}</div>
      </div>
    );
  }

  return <div className={styles.root}>{label}</div>;
}

function isPowerCapabilityId(capabilityId) {
  const baseCapabilityId = Capability.getBaseId(capabilityId);

  return baseCapabilityId === 'measure_power' || baseCapabilityId === 'meter_power';
}

function getPowerColor(value) {
  if (typeof value !== 'number') {
    return POWER_UNKNOWN_COLOR;
  }

  if (value < 0) {
    return POWER_EXPORT_COLOR;
  }

  return POWER_IMPORT_COLOR;
}
